export const addTagButtonStyles = {
  container: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  button: {
    padding: '4px 0',
    fontFamily: 'Inter',
    fontStyles: 'normal',
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '150%',
    color: '#23252F',
    textTransform: 'unset',
    alignSelf: 'flex-start',
  },
  paper: {
    marginTop: '8px',
    marginBottom: '8px',
    background: '#FFFFFF',
    border: '1px solid #F3F4F9',
    boxShadow:
      '0px 0px 0px 0px rgba(0, 23, 90, 0.04), -1px 7px 16px 0px rgba(0, 23, 90, 0.04), -3px 29px 29px 0px rgba(0, 23, 90, 0.03), -8px 65px 39px 0px rgba(0, 23, 90, 0.02), -14px 115px 46px 0px rgba(0, 23, 90, 0.01), -21px 180px 51px 0px rgba(0, 23, 90, 0.00)',
    borderRadius: '12px',
  },
  wrapper: { display: 'flex', padding: '8px 8px 20px' },
  sectionsContainer: {
    display: 'flex',
    width: '420px',
    flexDirection: 'column',
    padding: '8px 8px 0',
    gap: '20px',
    maxHeight: '460px',
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
      border: 'none',
      width: '11px',
      height: '11px',
      padding: '5px 0',
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: '#fff',
      border: 'none',
      height: '10px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#D4D6E0',
      width: '2px',
      borderRadius: '6px',
      cursor: 'pointer',
    },
  },
  titleContainer: { width: '100%', display: 'flex', justifyContent: 'flex-start' },
  title: {
    fontFamily: 'Inter',
    fontSize: '18px',
    fontWeight: '500',
    lineHeight: '148%',
    color: '#23252F',
  },
  selectsContainer: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    gap: '16px',
  },
  phaseContainer: { width: '100%', display: 'flex', flexDirection: 'column', gap: '8px' },
  phaseTextContainer: {
    display: 'flex',
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  selectTitle: {
    fontFamily: 'Inter',
    fontSize: '14px',
    lineHeight: '146%',
    color: '#131F1E',
  },
  optional: {
    fontFamily: 'Inter',
    fontSize: '12px',
    lineHeight: '150%',
    color: '#6E707A',
  },
  phaseSelectContainer: { display: 'flex', width: '100%' },
  scheduleItemContainer: { width: '100%', display: 'flex', flexDirection: 'column', gap: '8px' },
  scheduleItemTextContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  btnsContainer: {
    display: 'flex',
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  clearBtn: {
    textTransform: 'none',
    borderRadius: '8px',
    padding: '4px 0',
    color: '#23252F',
    fontFamily: 'Inter',
    lineHeight: '146%',
    fontSize: '14px',
    fontWeight: '400',
  },
  doneBtn: {
    background: '#4D6EF5',
    borderRadius: '8px',
    border: '1px solid #4D6EF5',
    padding: '8px 12px',
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '146%',
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    color: '#FFFFFF',
    transition: '300ms',
    textTransform: 'none',
    '&:hover': { color: '#4D6EF5' },
  },
  autocompleteParentContainer: {
    margin: '8px 0',
    padding: '8px 0',
    borderRadius: '12px',
    '& .MuiAutocomplete-listbox': {
      maxHeight: '200px',
      display: 'flex',
      flexDirection: 'column',
      gap: '4px',
      '& .MuiAutocomplete-option': {
        display: 'flex',
        width: '100%',
        padding: '14px 16px',
        '@media (min-width: 600px)': {
          minHeight: '48px',
        },
      },
      '&::-webkit-scrollbar': {
        border: 'none',
        width: '11px',
        height: '11px',
        padding: '5px 0',
      },
      '&::-webkit-scrollbar-track': {
        backgroundColor: '#fff',
        border: 'none',
        height: '10px',
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: '#D4D6E0',
        width: '2px',
        borderRadius: '6px',
        cursor: 'pointer',
      },
    },
  },
  autocompleteInput: {
    '& .MuiInputBase-root': {
      height: '36px',
      background: 'white',
      border: '1px solid #EDEFF7',
      borderRadius: '8px',
      outline: 'none',
      padding: '0',
    },
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        borderWidth: 0,
      },
      '&:hover fieldset': {
        borderWidth: 0,
      },
      '& fieldset': {
        borderWidth: 0,
      },
    },
  },
  autocompleteInputProfiles: {
    '& .MuiInputBase-root': {
      height: '48px',
      background: 'white',
      border: '1px solid #EDEFF7',
      borderRadius: '12px',
      outline: 'none',
      padding: '0',
    },
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        borderWidth: 0,
      },
      '&:hover fieldset': {
        borderWidth: 0,
      },
      '& fieldset': {
        borderWidth: 0,
      },
    },
  },
  optionValue: {
    fontFamily: 'Inter',
    fontSize: '14px',
    lineHeight: '146%',
    color: '#23252F',
  },
  tagsContainer: {
    display: 'flex',
    width: '100%',
    flexFlow: 'row wrap',
    justifyContent: 'flex-start',
    gap: '6px',
  },
};
